module.exports = __webpack_public_path__ + "img/img-4.a6380c38.png";